export default __webpack_public_path__ + "static/media/pro-elevate-lav-banner-3.b422e0d1.jpg";